/**
 * Lightweight GA4 event helpers.
 * gtag.js is loaded in /public/index.html with tag G-H21JL44PX2.
 * All helpers are safe to call before gtag is defined (guarded).
 */

const DEST = "marocanada.netlify.app";

/**
 * Return the eligibility form URL matching the current site language.
 * FR (default) → https://marocanada.netlify.app/
 * EN           → https://marocanada.netlify.app/en.html
 */
export const getEligibilityUrl = (lang) =>
  lang === "en"
    ? "https://marocanada.netlify.app/en.html"
    : "https://marocanada.netlify.app/";

export const trackCtaClick = (location) => {
  if (typeof window === "undefined") return;
  const gtag = window.gtag;
  if (typeof gtag !== "function") return;
  try {
    gtag("event", "cta_click", {
      cta_location: location,
      destination: DEST,
    });
  } catch {
    /* no-op */
  }
};
